'use client';

import {
  ASK_FOR_PRODUCT_DIALOG_ID,
  ProductAskDialog,
} from '@eliadmin/core/src/components/product/detail/product-ask-dialog';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { QuestionMarkCircledIcon } from '@radix-ui/react-icons';

export function ProductInquiryButton() {
  const product = useVariantsStore(state => state.product);
  const open = useDialogStore(state => state.open);
  const { t } = useTranslations();

  return (
    <Button
      type="button"
      size="lg"
      onClick={() =>
        open({
          id: ASK_FOR_PRODUCT_DIALOG_ID,
          content: <ProductAskDialog title={product.name} />,
        })
      }
      className={cn(
        'w-full text-base font-semibold shadow-md sm:text-lg',
        'ea-product-detail__primary-inquiry-button',
      )}
    >
      <QuestionMarkCircledIcon className="h-5 w-5" />
      {t('text446')}
    </Button>
  );
}
